import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import store from './store';
import addPv from '@/plugins/addPv/addPv';
import appShareInfo from '@/plugins/ShareInfo/appShareInfo';
import wxShareInfo from '@/plugins/ShareInfo/wxShareInfo';
import wxOpenApp from '@/plugins/WxOpenAppTip';
import routerThen from '@/plugins/routerThen/routerThen';
import AutoCachePage from '@/mixins/auto-cache-page';
import vConsole from 'vconsole';
import VueClipboard from 'vue-clipboard2';
import LazyLoad from '@/plugins/lazyLoad';
import scroll from 'vue-seamless-scroll';
import FlipCountdown from 'vue2-flip-countdown';
import 'swiper/css/swiper.min.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
Vue.use(Antd);
Vue.config.productionTip = false;
// * 注册全局重载页面事件，在App内登录后提予以调用
window.userInfoChange = () => {
  location.reload();
};
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(LazyLoad);
Vue.use(scroll);
Vue.use(FlipCountdown);
Vue.component('Swiper', Swiper);
Vue.component('SwiperSlide', SwiperSlide);
const devConsole =
  process.env.VUE_APP_NO_CONSOLE === 'true' ? 'no-console' : new vConsole();
new Vue({
  router,
  // store,
  render: (h) => h(App),
}).$mount('#app');
// 全局注册vue自定义插件
Vue.use(addPv)
  .use(appShareInfo)
  .use(wxShareInfo)
  .use(wxOpenApp)
  .use(routerThen, {
    router,
  });
// 全局混入vue mixin
Vue.mixin(AutoCachePage);
